import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "./MasterScreen.css";
import "./TransactionScreen.css";
import "./DashBoard.css";
import "./MenuBar.css";
import "./General.css";


//#region Global Storage ManageMent-Redux
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import SelectReducer from "./components/ReduxStore/Customeselect";
import MessageReducer from "./components/ReduxStore/Message";
import TransactionReducer from "./components/ReduxStore/Transactionstates";
const store = configureStore({
  reducer: {
    states: TransactionReducer,
    SelectOption: SelectReducer,
    Message: MessageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
//#endregion

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
